import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";

/**
 * Created by Jerker Nord on 2019-03-07.
 */

export class TextureHelper {

    /**
     * Renders a PIXI.Texture from a PIXI.Container
     * @param originalContainer
     * @param resolution
     */
    public static createRenderedTextureFromContainer(originalContainer:PIXI.Container, resolution:number = 1):PIXI.RenderTexture {
        let renderTexture:PIXI.RenderTexture = PIXI.RenderTexture.create({
            width: (originalContainer.width),
            height:(originalContainer.height),
            scaleMode: PIXI.SCALE_MODES.LINEAR,
            resolution: resolution
        }); //PIXI.SCALE_MODES.LINEAR, resolution
        StageManager.renderer.render(originalContainer, renderTexture);
        return renderTexture;
    }

    /**
     * Removes connection to Spritesheet (BaseTexture) from textures
     * @param textures
     */
    public static removeBaseTextures(textures:PIXI.Texture[]):PIXI.Texture[]{
        const fixedTextures:PIXI.Texture[] = [];
        let textureName:string;
        let newTexture:PIXI.Texture;

        for(let i:number = 0; i < textures.length; i++) {
            if(textures[i].width !== textures[i].baseTexture.realWidth || textures[i].height !== textures[i].baseTexture.realHeight) {
                textureName = textures[i].textureCacheIds[0];
                newTexture = TextureHelper.createRenderedTextureFromContainer(new PIXI.Container().addChild(new PIXI.Sprite(textures[i])), textures[i].baseTexture.resolution);
                textures[i].destroy();
                PIXI.Texture.removeFromCache(textures[i]);
                fixedTextures.push(newTexture);
            }
        }

        return fixedTextures;
    }
}